import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { BoldTitle, Container } from 'common/components';
import { selectIsSmallScreen } from '../../../store/pageStore';
import { CatalogueSection, CatalogueContent, ContainerStyles } from './components';
import { catalogueSubtitleStyles } from './components/catalogue-content/styles';

export const Catalogue = () => {
	const isSmallScreen = useSelector(selectIsSmallScreen);

	return (
		<CatalogueSection id="catalogue">
			<Container className={ContainerStyles}>
				<Typography variant={isSmallScreen ? 'h2' : 'h1'} as="h2" className={BoldTitle}>
					Услуги Лемана ПРО
				</Typography>
				<Typography
					variant={isSmallScreen ? 'm' : 'l'}
					size="body_short"
					className={catalogueSubtitleStyles}
					overrideStyles={false}
				>
					Выберите нужную услугу, ознакомьтесь с описанием и закажите её на сайте.
				</Typography>
				<CatalogueContent />
			</Container>
		</CatalogueSection>
	);
};
